import { Twitter, Facebook, Instagram } from "lucide-react";

const PinterestIcon = ({ size = 26 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12.017 2C6.48 2 2 6.48 2 12.017c0 4.25 2.65 7.876 6.39 9.334-.088-.793-.167-2.01.035-2.877.182-.78 1.172-4.97 1.172-4.97s-.3-.6-.3-1.486c0-1.39.806-2.428 1.81-2.428.853 0 1.265.64 1.265 1.408 0 .858-.546 2.14-.828 3.33-.236.995.5 1.807 1.48 1.807 1.778 0 3.144-1.874 3.144-4.58 0-2.393-1.72-4.068-4.176-4.068-2.845 0-4.516 2.135-4.516 4.34 0 .859.33 1.78.744 2.28a.3.3 0 0 1 .07.288c-.076.315-.245.995-.278 1.134-.043.183-.145.222-.334.134-1.249-.581-2.03-2.407-2.03-3.874 0-3.154 2.292-6.052 6.608-6.052 3.469 0 6.165 2.472 6.165 5.776 0 3.447-2.173 6.22-5.19 6.22-1.013 0-1.966-.527-2.292-1.148l-.623 2.378c-.226.868-.835 1.958-1.244 2.622.937.29 1.931.446 2.962.446 5.537 0 10.017-4.48 10.017-10.017C22.034 6.48 17.554 2 12.017 2z" />
  </svg>
);

const LEGAL = [
  "Privacy Policy",
  "Accessibility Statement",
  "Shipping Policy",
  "Terms & Conditions",
  "Refund Policy",
];

const SOCIALS = [
  { icon: Twitter, label: "X", href: "https://x.com/SeatechAquarium" },
  { icon: Facebook, label: "Facebook", href: "https://www.facebook.com/seatechaquariums/" },
  { icon: PinterestIcon, label: "Pinterest", href: "https://www.pinterest.com/seatechaquariums/?invite_code=a8a06ff94cc94700b20fc2dc1f106b21&sender=701998798075066989" },
  { icon: Instagram, label: "Instagram", href: "https://www.instagram.com/seatechaquariums/" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative pt-10 lg:pt-14 pb-10 lg:pb-14">
    <div className="w-full max-w-[1860px] mx-auto px-5 lg:px-14">
      <div className="rounded-[2rem] bg-[#5a3fe0] px-10 lg:px-16 py-14 lg:py-20 grid lg:grid-cols-2 gap-14">
        {/* Left: legal links + credit */}
        <div>
          <ul className="space-y-3">
            {LEGAL.map((l) => (
              <li key={l}>
                <a
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  data-testid={`footer-legal-${l.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
                  className="font-body text-base text-white/90 hover:text-white transition-colors"
                >
                  {l}
                </a>
              </li>
            ))}
          </ul>
          <p className="font-body text-sm text-white/70 mt-14">
            © {new Date().getFullYear()} Powered by CREATRVERSE
          </p>
        </div>

        {/* Right: socials + contact info */}
        <div className="lg:pl-10">
          <div className="flex items-center gap-5">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={s.label}
                data-testid={`footer-social-${s.label.toLowerCase()}`}
                className="text-white/90 hover:text-white transition-colors"
              >
                <s.icon size={26} strokeWidth={1.8} />
              </a>
            ))}
          </div>

          <div className="border-t border-white/25 my-8" />

          <div className="font-body text-lg lg:text-xl text-white/95 space-y-2">
            <p><a href="tel:+16026287270" className="hover:text-white">602-628-7270</a></p>
            <p><a href="mailto:jimmie@seatechaquariums.com" className="hover:text-white">jimmie@seatechaquariums.com</a></p>
            <p>PO Box 83085</p>
            <p>Phoenix AZ 85071</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
);
